import { toast } from "sonner";
import { Copy } from "lucide-react";

interface CopyButtonProps {
  text: string;
  size?: number;
}

export const CopyButton = ({ text, size = 10 }: CopyButtonProps) => {
  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(String(text));
      toast("Скопировано в буфер обмена");
    } catch {
      toast("Не удалось скопировать");
    }
  };
  return (
    <div className="w-fit flex items-center flex-shrink-0">
      <button
        onClick={handleCopy}
        className="p-2 hover:bg-accent rounded-sm duration-100 hover:text-primary text-muted-foreground"
      >
        <Copy size={size} />
      </button>
    </div>
  );
};
